import { render } from "./PayProvider.vue?vue&type=template&id=dd978bf6&scoped=true"
import script from "./PayProvider.vue?vue&type=script&lang=js"
export * from "./PayProvider.vue?vue&type=script&lang=js"

import "./PayProvider.vue?vue&type=style&index=0&id=dd978bf6&scoped=true&lang=css"

import exportComponent from "/opt/apps/acquiring_front_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd978bf6"]])

export default __exports__